import { ArrowTopLeftBoldOutlineIcon } from './ArrowTopLeftBoldOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 4D43349E-EF13-4BB1-9684-0CEDE55DE9DE
 * name arrow-top-left-bold-outline
 * version: 2.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-top-left-bold-outline.svg
 * tags
 * - Arrow 
 */
export const ArrowUpLeftBoldOutlineIcon = ArrowTopLeftBoldOutlineIcon;
export default ArrowUpLeftBoldOutlineIcon